import React from "react"
import TallCard from "../../internal/tallCard/TallCard"

function TallCustomCardWidget({ blok }) {

  return (
    <TallCard 
      thumbnail={blok.thumbnail}
      show_video_button={blok.show_video_button === "yes"}
      video_url={blok.video_url}
      type={blok.type}
      title={blok.title}
      description={blok.description}
      cta_label={blok.cta_label}
      cta_link={blok.cta_link}
      cta_target={blok.link_new_tab} />
  )
}

export default TallCustomCardWidget